import Vue from "vue";
Vue.component("search-bar-vue", {
  mounted() {
    const crossBtn = document.querySelector(".searchPill__cross-button");
    const inputField = document.querySelector(".searchPill-input");
    const inputFieldAutoComplete = document.querySelector(".searchPill-input-auto-complete");
    const searchBtn = document.querySelectorAll('.search-bar__search .btn');

    inputField.addEventListener('input', function() {
      if (inputField.value !== '') {
        crossBtn.classList.remove('searchPill__cross-button-disable')
      }
      else {
        crossBtn.classList.add('searchPill__cross-button-disable')
      }
    })

    function clearErrors() {
      searchBtn.forEach(item => {
        item.classList.remove("search-btn-disable");
      })
    }

    crossBtn.addEventListener("click", function(event) {
      event.preventDefault();
      inputField.value = "";
      inputFieldAutoComplete.value = "";
      crossBtn.classList.add('searchPill__cross-button-disable');
      clearErrors();
    });

    //advanced filter modal
    var modal = document.querySelector(".filter-modal");
    var filterBtn = document.querySelectorAll(".search-bar__filter");
    var closeBtn = document.querySelector('.filter-modal .advanced-filters-close-btn');
    var cancelBtn = document.querySelector('.filter-modal .btn_cancel');

    filterBtn.forEach(item => {
      item.onclick = function(event) {
        event.preventDefault();
        modal.style.display = "block";
      }
    })
    closeBtn.onclick = function() {
      modal.style.display = "none";
    }
    cancelBtn.onclick = function() {
      modal.style.display = "none";
    }
    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }

    //tag
    const closeTagButton = this.$el.querySelectorAll(".tag__icon");
    if (closeTagButton.length) {
      closeTagButton.forEach(element => {
        element.addEventListener("click", function(e) {
          const ele = e.target;
          const eletag = ele.closest('.tag');
          eletag.remove();
        });
      });
    }
    //search auto complete for testing purpose should be removed real data is integrated
    $(".search-bar .searchPill-input").keyup(function() {
      var backgroundInput = $(".search-bar .searchPill-input-auto-complete");
      backgroundInput.val('');
      var autoCompleteText = localStorage.getItem('searchText');
      var searchText = $(this).val();
      if (searchText === "") {
        backgroundInput.val('');
      } else if (autoCompleteText.toLowerCase().indexOf(searchText.toLowerCase()) == 0) {
        var currentLength = searchText.length;
        backgroundInput.val(searchText + "" + autoCompleteText.substring(currentLength));
      }
    });

    function updateListWidth() {
      const searchBarInput = document.querySelector('.search-bar__input');
      const dynamicList = document.querySelector('.auto-complete-wrapper');
      const itemWidth = searchBarInput.clientWidth;
      dynamicList.style.width = itemWidth + 'px';
    }
    window.addEventListener('resize', updateListWidth);

  }
});
